
export class PCodeConfig
{
	static azureAd: PCodeConfigAzureAd =
		{
			enabled: false,
			tenantId: null,
			clientId: null,
			graphApiUrl: 'https://graph.microsoft.com/v1.0/'
		}

	static vapid: PCodeConfigVapid =
		{
			publicKey: 'BKs-gr4Ax565YXCxSgqOvO9O19zQUG_P5vAz_bfhiamTRQNqFeT1wUtHX4cL4JX3oG8x8HCo5P0pIYzmOZ3eitQ'
		}
}

interface PCodeConfigAzureAd
{
	enabled: boolean;
	tenantId: string;
	clientId: string;
	graphApiUrl: string;
}
interface PCodeConfigVapid
{
	publicKey: string;
}